import {
    LOG_IN_REQUEST,
    LOG_IN_SUCCESS,
    LOG_IN_FAILURE,
    LOG_OUT,
    CHECK_USERNAME_REQUEST,
    CHECK_USERNAME_SUCCESS,
    CHECK_USERNAME_FAILURE,
    STORE_SECURITY_CODE,
    DELETE_SECURITY_CODE,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    GET_SUPPORT_CONNECTION_REQUEST,
    GET_SUPPORT_CONNECTION_SUCCESS,
    GET_SUPPORT_CONNECTION_FAILURE,
    CONNECT_TO_SUPPORT_VPN_REQUEST,
    CONNECT_TO_SUPPORT_VPN_SUCCESS,
    CONNECT_TO_SUPPORT_VPN_FAILURE
} from '../actions/authActionTypes';

const initialState = {
    username: '',
    permissions: null,
    isAdmin: false,
    isLogginIn: false,
    error: false,
    passwordReset: {
        securityCode: null,
        email: null,
        isSending: false,
        error: false,
        isReseting: false,
        resetError: false
    },
    supportConnection: {
        fetching: false,
        error: false,
        connecting: false,
        connectionError: false,
        licence: null,
        licenceStatus: 'common:inactive',
        ip: null,
        vpnStatus: 'common:unconnected'
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOG_IN_REQUEST: {
            return {
                ...state,
                isLogginIn: true
            };
        }
        case LOG_IN_SUCCESS: {
            return {
                ...state,
                username: action.payload.username,
                permissions: action.payload.permissions!==null ? action.payload.permissions.split(',') : null,
                isAdmin: action.payload.isAdmin,
                isLogginIn: false,
                error: false
            };
        }
        case LOG_IN_FAILURE: {
            return {
                ...state,
                isLogginIn: false,
                error: true
            };
        }
        case LOG_OUT: {
            return initialState;
        }
        case CHECK_USERNAME_REQUEST: {
            return {
                ...state,
                username: '',
                passwordReset: {
                    ...state.passwordReset,
                    isSending: true,
                    error: false
                }
            };
        }
        case CHECK_USERNAME_SUCCESS: {
            return {
                ...state,
                username: action.payload.username,
                passwordReset: {
                    ...state.passwordReset,
                    email: action.payload.email,
                    isSending: false,
                    error: false
                }
            };
        }
        case CHECK_USERNAME_FAILURE: {
            return {
                ...state,
                username: '',
                passwordReset: {
                    ...state.passwordReset,
                    securityCode: null,
                    email: null,
                    isSending: false,
                    error: true
                }
            };
        }
        case STORE_SECURITY_CODE: {
            return {
                ...state,
                passwordReset: {
                    ...state.passwordReset,
                    securityCode: action.payload.securityCode
                }
            };
        }
        case DELETE_SECURITY_CODE: {
            return {
                ...state,
                passwordReset: {
                    ...state.passwordReset,
                    securityCode: null
                }
            };
        }
        case RESET_PASSWORD_REQUEST: {
            return {
                ...state,
                passwordReset: {
                    ...state.passwordReset,
                    isReseting: true,
                    resetError: false
                }
            }
        }
        case RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                passwordReset: {
                    ...state.passwordReset,
                    isReseting: false,
                    resetError: false,
                }
            }
        }
        case RESET_PASSWORD_FAILURE: {
            return {
                ...state,
                passwordReset: {
                    ...state.passwordReset,
                    isReseting: false,
                    resetError: true
                }
            }
        }
        case GET_SUPPORT_CONNECTION_REQUEST: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    fetching: true
                }
            };
        }
        case GET_SUPPORT_CONNECTION_SUCCESS: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    fetching: false,
                    error: false,
                    licence: action.payload.licence,
                    licenceStatus: action.payload.licenceStatus,
                    ip: action.payload.ip,
                    vpnStatus: action.payload.vpnStatus
                }
            };
        }
        case GET_SUPPORT_CONNECTION_FAILURE: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    fetching: false,
                    error: true
                }
            };
        }
        case CONNECT_TO_SUPPORT_VPN_REQUEST: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    connecting: true
                }
            };
        }
        case CONNECT_TO_SUPPORT_VPN_SUCCESS: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    connecting: false,
                    connectionError: false,
                    ip: action.payload.ip,
                    vpnStatus: action.payload.vpnStatus
                }
            };
        }
        case CONNECT_TO_SUPPORT_VPN_FAILURE: {
            return {
                ...state,
                supportConnection: {
                    ...state.supportConnection,
                    connecting: false,
                    connectionError: true
                }
            };
        }
        default:
            return state;
    }
};
